<div class="video-container">
    <button type="button" class="overlay" (click)="onClickClose()" tabindex="0"></button>
    <div class="video__wrap">
        <div class="header">
            <button (click)="onClickClose()">X</button>
        </div>
        <div class="video">
          @if (!isVideoPlaying) {
            <button (click)="onPlayClick()" class="play-btn"><img src="assets/icons/play-button.svg" alt=""></button>
          }
          <video 
          #videoPlayer
          [src]="data.videoUrl" 
          class="w-full"
        ></video>
        </div>
    </div>
  </div>